export class Site {
  public id: string;
  public customerId: string;
  public isActive: string;
  public customerName: string;
  public customerShortName: string;
  public location: string;
  public locationShort: string;
  public endUser: string;
  public contactNameOne: string;
  public contactNumberOne: string;
  public contactEmailOne: string;
  public contactNameTwo: string;
  public contactNumberTwo: string;
  public contactEmailTwo: string;

  constructor (
    id = '',
    customerId = '',
    customerName = '',
    customerShortName = '',
    location = '',
    locationShort = '',
    endUser = '',
    contactNameOne = '',
    contactNumberOne = '',
    contactEmailOne = '',
    contactNameTwo = '',
    contactNumberTwo = '',
    contactEmailTwo = '',
    isActive = ''
  ) {}
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/site.ts